module.exports = __webpack_public_path__ + "img/xmas2025.53cbc848.jpg";